import React, { Fragment, PureComponent } from 'react';
import styled, { withTheme } from 'styled-components';
import { Trans, withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Form, FormControl, FormActions, FormRow } from '../../inputs/Form';
import Buttons from '../../buttons';
import EmailInput from '../../inputs/EmailInput';
import PasswordInput from '../../inputs/PasswordInput';
import Link from '../../buttons/Link';
import { CollectionItemHeader } from '../../typography/Content';
import FirstNameInput from '../../inputs/FirstNameInput';
import LastNameInput from '../../inputs/LastNameInput';
import AgreeToTermsCheckBox from '../../inputs/AgreeToTermsCheckBox';
import CaptchaInput from '../../inputs/CaptchaInput';

const AlternateActions = styled.div`
  flex: 1;
  & > * {
    display: block;
  }
`;

class RegisterEmailForm extends PureComponent {
  static contextTypes = {
    environment: PropTypes.object,
    functions: PropTypes.object,
  };

  static defaultProps = {
    inputValue: '',
    onSubmit: () => true,
    state: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value || { email: props.inputValue },
    };
  }

  handleSubmit = (values, _, __, handleServerResponse) => {
    const { onSubmit } = this.props;
    onSubmit(values, handleServerResponse);
  };

  render() {
    const {
      api,
      hidePasswordField,
      ssoNotice = false,
      enforceSso = false,
      autoFocus,
      theme,
      token,
      state,
      loading,
      t,
      i18n,
      onContinueSSO,
      onChange,
    } = this.props;
    const { environment, functions } = this.context;
    const { value } = this.state;

    const alternateActions = (
      <AlternateActions>
        <CollectionItemHeader>{t('commonPlat:labels.haveAnAccount')}</CollectionItemHeader>
        <Link
          to={{
            pathname: theme.urls.routes.loginUser,
            query: { token },
            state,
          }}
        >
          {t('commonPlat:actions.signIn')}
        </Link>
      </AlternateActions>
    );

    return (
      <Form value={value} onSubmit={this.handleSubmit} onChange={onChange}>
        <FormControl label={t('commonPlat:labels.emailAddress')}>
          <EmailInput id={'email'} required autoFocus={autoFocus} />
        </FormControl>
        {hidePasswordField && ssoNotice}
        {!enforceSso && (
          <Fragment>
            <FormRow>
              <FormControl label={t('commonPlat:labels.firstName')}>
                <FirstNameInput id={'firstName'} required />
              </FormControl>
              <FormControl label={t('commonPlat:labels.lastName')}>
                <LastNameInput id={'lastName'} required />
              </FormControl>
            </FormRow>
            <FormRow>
              <FormControl label={t('commonPlat:labels.password')}>
                <PasswordInput id={'password'} required />
              </FormControl>
              <FormControl label={t('commonPlat:labels.confirmPassword')}>
                <PasswordInput id={'confirmPassword'} required />
              </FormControl>
            </FormRow>
            <FormRow>
              <FormControl>
                <CaptchaInput
                  id="captcha"
                  api={api}
                  requiredFieldError={`Complete the captcha challenge to continue`}
                  required
                />
              </FormControl>
            </FormRow>
            <FormControl
              label={
                <Trans parent={'span'} t={t} i18nKey="commonPlat:labels.agreeTerms">
                  I am 13 years of age or older and agree to Do Some Good's{' '}
                  <Link href={theme.urls.legal.terms(environment, functions, i18n)}>
                    Terms of Service
                  </Link>
                </Trans>
              }
            >
              <AgreeToTermsCheckBox id={'agreeTerms'} required />
            </FormControl>
          </Fragment>
        )}
        <FormActions hideClientError alternateActions={alternateActions}>
          {!enforceSso && (
            <Buttons.Primary disabled={loading} type={'submit'}>
              {t('commonPlat:labels.createAccount')}
            </Buttons.Primary>
          )}
          {!!enforceSso && (
            <Buttons.Primary onClick={onContinueSSO}>
              {t('commonPlat:actions.continueSSO')}
            </Buttons.Primary>
          )}
        </FormActions>
      </Form>
    );
  }
}

export default withTheme(withTranslation(['commonPlat'])(RegisterEmailForm));
